"use client"

import React from 'react';
import Login from "@/components/Login/Login";
import Languages from "@/components/Languages/Languages";
import {Link} from "@/i18n/routing";
import LoadAppData from "@/components/LoadAppData/LoadAppData";
import {useAppStore} from "@/store/AppStore";
import {AppBar, Box, Stack, Toolbar} from "@mui/material";
import MenuBtn from "@/components/Menu/MenuBtn/MenuBtn";
import useCheckAuth from "@/utils/hooks/useCheckAuth";
import Logo from "@/components/Logo/Logo";


const TopBar = () => {
  const cats = useAppStore((state) => {
    return state.cats
  })
  const types = useAppStore((state) => {
    return state.types
  })

  useCheckAuth()

  return (
    <AppBar>
      {(!cats || !types) && <LoadAppData/>}
      <Toolbar>
        <MenuBtn/>
        <Box sx={{flexGrow: 1}}/>
        <Link href={`/home`}>
          <Logo width={200} height={60} style={{marginTop: '0.3rem'}}/>
        </Link>
        <Box sx={{flexGrow: 1}}/>
        <Stack direction={"row"} sx={{alignItems: "center"}} spacing={4}>
          <Languages/>
          <Login/>
        </Stack>
      </Toolbar>
    </AppBar>)
};

export default TopBar;
